import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";
import { buildHead } from "@/lib/seo";
import { HOWTO_LD, FAQ_LD, BREADCRUMB_LD } from "@/lib/ld/how-it-works";

const TITLE =
  "How LohaLink Works — Verification, Escrow, AI Grading & Logistics for B2B Scrap Trade";
const DESCRIPTION =
  "Behind the scenes of every bulk scrap metal trade on LohaLink: GST & PAN verification, AI-benchmarked pricing, RBI-grade nodal escrow, live truck tracking, digital weighbridge reconciliation, dispute resolution and GST e-invoicing — for HMS, sponge iron, MS billets, iron ore and ferro-alloys across India.";

export const Route = createFileRoute("/_app/how-it-works")({
  head: () =>
    buildHead({
      title: TITLE,
      description: DESCRIPTION,
      canonical: "/how-it-works",
      ogType: "article",
      extraMeta: [
        { property: "og:image:width", content: "1216" },
        { property: "og:image:height", content: "630" },
        {
          property: "og:image:alt",
          content: "How LohaLink works — KYC, escrow, AI grading and live tracking",
        },
      ],
      jsonLd: [HOWTO_LD, FAQ_LD, BREADCRUMB_LD],
    }),
  component: lazyRouteComponent(() => import("@/pages/HowItWorks")),
});
